/* eslint-disable */
// AIレポート機能のAPIクライアント (保護者モバイル / CCS HOME)。
// モック/実APIは VUE_APP_AI_REPORT_USE_MOCK で切替可能。
// 保護者側は `status=published` のレポートのみ取得可能。

import ApiClient from "@/api/ApiClient";
import { mockGetPublished, mockListPublished } from "@/mock/aiReport";

const USE_MOCK = process.env.VUE_APP_AI_REPORT_USE_MOCK === 'true';

// =====================================================================
// 型定義
// =====================================================================

export type AiReportQuarter = 1 | 2 | 3 | 4;

/** システム固定言語 (content_en / content_ja / content_km) */
export type AiReportStoredLanguage = "en" | "ja" | "km";

/** 園が翻訳しうる言語 (システム外含む) */
export type AiReportContentLanguage =
  | AiReportStoredLanguage
  | "ko"
  | "zh"
  | "vi"
  | "hi"
  | "ru"
  | "bn"
  | "mn"
  | "tl"
  | "ms";

export interface AiReportListItem {
  childId: number;
  childLastName: string;
  childFirstName: string;
  businessYear: number;
  quarter: AiReportQuarter;
  monthsLabel: string;
  // タイトル例: "2歳11ヶ月のVEVOレポート 2026年12月時点"
  title: string;
  publishedAt: string;
  dataCoverageMonths: number[];
}

export interface AiReportDetail extends AiReportListItem {
  /** 翻訳済み: 翻訳先本文 / 未翻訳: 保護者言語設定に応じた本文 */
  content: string;
  contentEn: string | null;
  contentJa: string | null;
  contentKm: string | null;
  /**
   * 園が翻訳した先の言語コード (additional_prompt = Translation: xxx から復元)。
   * 未翻訳 (Case1) のときは null。
   */
  contentLanguage: AiReportContentLanguage | null;
}

// =====================================================================
// APIクライアント
// =====================================================================

export default class ApiAiReport {
  /**
   * 公開済AIレポートの一覧を取得する。
   */
  static async listPublished({
    childId,
  }: {
    childId: number;
  }): Promise<AiReportListItem[]> {
    if (USE_MOCK) {
      return mockListPublished(childId);
    }
    const response = await ApiClient.get(
      `/child-development/ai-report/parents/children/${childId}`,
      null,
    );
    return response as AiReportListItem[];
  }

  /**
   * 個別の公開済AIレポートを取得する。
   */
  static async getPublished({
    childId,
    businessYear,
    quarter,
  }: {
    childId: number;
    businessYear: number;
    quarter: AiReportQuarter;
  }): Promise<AiReportDetail | null> {
    if (USE_MOCK) {
      return mockGetPublished(childId, businessYear, quarter);
    }
    const response = await ApiClient.get(
      `/child-development/ai-report/parents/children/${childId}/${businessYear}/${quarter}`,
      null,
    );
    return response as AiReportDetail;
  }
}
